<template>
  <button :class="classNames" :style="styles" @click.stop="onClick">
    <slot></slot>
  </button>
</template>

<script>
export const ButtonColor = Object.freeze({
  none: 'none',
  brand: 'brand',
  gray: 'gray',
  white: 'white',
  disable: 'disable',
  inactive: 'inactive',
  warning: 'warning',
  emergency: 'emergency'
})

export default {
  name: 'VButton',
  props: {
    color: {
      type: String,
      default: 'white'
    },
    radius: {
      type: Number,
      default: 0
    },
    onClick: {
      type: Function,
      default: () => {}
    },
    isDisable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classNames() {
      return ['default', `${this.color}-button`, this.isDisable && 'gray-button']
    },
    styles() {
      return {
        borderRadius: `${this.radius}px`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';
@import '~@/assets/scss/modules/text';

.default {
  cursor: pointer;
  box-sizing: border-box;
  text-align: center;
}

.none-button {
  background-color: transparent;
}

.brand-button {
  background-color: $brand;
}

.gray-button {
  background-color: $gray-2;
}

.white-button {
  background-color: $white;
}

.disable-button {
  background-color: $light-gray-5;
}

.inactive-button {
  background-color: $light-gray;
}

.warning-button {
  background-color: $orange;
}

.emergency-button {
  background-color: $red;
}

.extra-thin {
  font-weight: $extra-bold;
}

.thin {
  font-weight: $thin;
}

.regular {
  font-weight: $regular;
}

.bold {
  font-weight: $bold;
}

.extra-bold {
  font-weight: $extra-bold;
}
</style>